
import React from 'react'
import {
    List,
    Datagrid,
    Edit,
    Create,
    SimpleForm,
    DateField,
    TextField,
    ArrayField,
    SingleFieldList,
    EditButton,
    TextInput,
    DateInput,
    Responsive,
    SimpleList,
    SimpleShowLayout,
    ShowButton,
    Show,
    UrlField,
    SelectInput,
    Filter,
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    Pagination,
    Button,
    ChipField,
    required,
    sanitizeListRestProps,
    SaveButton,
    DeleteButton,
    Toolbar,
    NumberInput,
    FileInput,
    FileField,
    translate,
    ImageField,
    ReferenceField,
    ReferenceInput,
    RichTextField,
    BooleanField,
    BooleanInput,
    AutocompleteInput,
    SearchInput,
    FunctionField,
} from 'react-admin'
import { cloneElement, useMemo } from 'react'
import PropTypes from 'prop-types'
import BookIcon from '@material-ui/icons/BookOutlined'
import RichTextInput from 'ra-input-rich-text';
import OptionalImageField from '../Customs/OptionalImageField'
import dataProvider from '../dataProvider'

const API_URL = process.env.REACT_APP_API_HOSTNAME

export const TextIcon = BookIcon

const Text_Filter = (props) => (
    <Filter {...props}>
        <SearchInput source="search" alwaysOn />
        <TextInput source="fullname" options={{ maxLength: 1024 }} />
    </Filter>
)

const ListActions_Store = {}

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props
    let {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
    } = useListContext()
    ListActions_Store.filterValues = filterValues
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} />
        </TopToolbar>
    )
}

export const TextList = (props) => (
    <List {...props} filters={<Text_Filter />} actions={<ListActions />} perPage={50}>
        <Responsive
            small={
                <SimpleList linkType="show"
                    primaryText={record => record ? record.fullname : ''}
                />
            }
            medium={
                <Datagrid>
                    <TextField source="fullname" sortable={false} />
                    <FunctionField label="Words Count" render={(record) => record.content.split('\n').join(' ').split(' ').filter(e => !!e).length} />
                    <DateField source="updatedAt" showTime={true} sortable={true} />
                    <EditButton />
                    <ShowButton />
                </Datagrid>
            }
        />
    </List>
)


export const TextShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="fullname" />
            <RichTextField source="content" />
            <FunctionField label="Words Count" render={(record) => record.content.split('\n').join(' ').split(' ').filter(e => !!e).length} />
            <TextField source="content" />
            <DateField source="createdAt" showTime={true} />
            <DateField source="updatedAt" showTime={true} />
        </SimpleShowLayout>
    </Show>
)

const CustomToolBar = props => <Toolbar {...props} ><SaveButton /></Toolbar>

export const TextEdit = (props) => (
    <Edit {...props} undoable={false} toolbar={<CustomToolBar />} >
        <SimpleForm redirect="show">
            <RichTextInput source="content" validate={required()} />
        </SimpleForm>
    </Edit>
)

export const TextCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect="show">
            <TextInput source="name" validate={required()} />
            <RichTextInput source="content" validate={required()} />
        </SimpleForm>
    </Create>
)

